import React from "react";

export const NumberedParapgrahs = (props) => {
  const pstyle = {
    fontSize: props.data?.fontSize || "1em",
    lineHeight: "1.5em",
  };
  const istyle = {
    width: "100%",
    height: "auto",
    maxWidth: "100%",
    display: "block",
    objectFit: "cover",
  };
  const dstyle = {
    display: "flex",
    alignItems: "center",
  };
  const cstyle = {
    backgroundColor: props.data?.backgroundColor || "white",
    color: "#606060",
    marginBottom: "1em",
    padding: "4em",
  };
  return (
    <div id={props?.anchor} style={cstyle}>
      <div className="container">
        <div className="row" >
          <div className="col-xs-12 col-md-5 text-center">
            {" "}
            <img src={props.data?.img} alt="" className="img-responsive" />{" "}
          </div>
          <div id="np" className="col-xs-12 col-md-7">
              <div className="about-text">
              {
                props.data?.items.map((p, i) => (
                  <div className="text-item">
                    <div className="circle">{i+1}</div>
                    <p key={i} style={pstyle}>{p}</p>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
